import {create} from 'zustand';
import {ActivityPay, BalanceConfig} from './recharge-tab/recharge-tab.service';
import {BalanceListItem} from './recharge.service';

interface RechargeState {
  // Tabs数据
  tabs: ActivityPay[];
  // 当前选中的tab ID
  activeTabId: number | undefined;
  // 加载状态
  loading: boolean;
  // 错误信息
  error: string | null;
  // 是否显示余额列表
  canShowBalanceList: boolean;
  balanceList: BalanceListItem[];
  balanceConfig: BalanceConfig[];

  // Actions
  setTabs: (tabs: ActivityPay[]) => void;
  setActiveTabId: (tabId: number) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setBalanceList: (balanceList: BalanceListItem[]) => void;
  setCanShowBalanceList: (canShow: boolean) => void;
  setBalanceConfig: (balanceConfig: BalanceConfig[]) => void;
  // 更新单个tab的选中状态
  updateTabActiveStatus: (tabId: number, isActive: boolean) => void;

  // 重置状态
  reset: () => void;
}

const initialState = {
  tabs: [],
  activeTabId: undefined,
  loading: false,
  error: null,
  canShowBalanceList: false,
  balanceList: [],
  balanceConfig: [],
};

export const useRechargeStore = create<RechargeState>((set, get) => ({
  ...initialState,

  setTabs: (tabs: ActivityPay[]) => {
    set({tabs});

    // 如果没有选中的tab，自动选择第一个
    const {activeTabId} = get();
    if (!activeTabId && tabs.length > 0) {
      const activeTab = tabs.find(tab => tab.id === activeTabId);
      if (activeTab) {
        set({activeTabId: activeTab.id});
      } else {
        set({activeTabId: tabs[0].id});
      }
    }
  },

  setActiveTabId: (tabId: number) => {
    set({activeTabId: tabId});
  },

  setLoading: (loading: boolean) => {
    set({loading});
  },

  setError: (error: string | null) => {
    set({error});
  },

  setCanShowBalanceList: (canShow: boolean) => {
    set({canShowBalanceList: canShow});
  },

  updateTabActiveStatus: (tabId: number, isActive: boolean) => {
    const {tabs} = get();
    const updatedTabs = tabs.map(tab => ({
      ...tab,
      isActive: tab.id === tabId ? isActive : false,
    }));
    set({tabs: updatedTabs});
  },

  reset: () => {
    set(initialState);
  },
  setBalanceList: (balanceList: BalanceListItem[]) => {
    set({balanceList});
  },
  setBalanceConfig: (balanceConfig: BalanceConfig[]) => {
    set({balanceConfig});
  },
}));
